module.exports = __webpack_public_path__ + "static/media/success.031df4d9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/sound/success.mp3
// module id = 1448
// module chunks = 0